import Link from 'next/link';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';


import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"


import Language from './Language';
import { Button } from '@/components/ui/button';
import { useState, useEffect, useRef } from 'react';
import USFlag from '@/assets/flags/US.svg'; // Adjust the path to the US flag SVG file
import UKFlag from '@/assets/flags/GB.svg';
import ARFlag from '@/assets/flags/ar.svg';
import BPFlag from '@/assets/flags/BR.svg';
import FCFlag from '@/assets/flags/fr-CA.svg';
import SCFlag from '@/assets/flags/CN.svg';
import DNFlag from '@/assets/flags/DK.svg';
import FRFlag from '@/assets/flags/FR.svg';
import GRFlag from '@/assets/flags/DE.svg';
import GKFlag from '@/assets/flags/GR.svg';
import HIFlag from '@/assets/flags/IN.svg';
import ITFlag from '@/assets/flags/IT.svg';
import JPFlag from '@/assets/flags/JP.svg';
import KNFlag from '@/assets/flags/tlh.svg';
import KRFlag from '@/assets/flags/KR.svg';
import LatinFlag from '@/assets/flags/la-2.svg';
import LAFlag from '@/assets/flags/es-419.svg';
import PTFlag from '@/assets/flags/PT.svg';
import RUFlag from '@/assets/flags/RU.svg';
import SPFlag from '@/assets/flags/ES.svg';
import TKFlag from '@/assets/flags/TR.svg';
import TCFlag from '@/assets/flags/HK.svg';

let languageMap = {
  en: USFlag,
  ar: ARFlag,
  "en-GB": UKFlag,
  "pt-BR": BPFlag,
  "fr-CA": FCFlag,
  "zh-CN": SCFlag,
  da: DNFlag,
  fr: FRFlag,
  de: GRFlag,
  el: GKFlag,
  hi: HIFlag,
  it: ITFlag,
  ja: JPFlag,
  tlh: KNFlag,
  ko: KRFlag,
  "la": LatinFlag,
  "es-419": LAFlag,
  pt: PTFlag,
  ru: RUFlag,
  es: SPFlag,
  tr: TKFlag,
  "zh-TW": TCFlag,
};

export default function () {
  let [language, setLanguage] = useState(null);

  useEffect(() => {
    if (!language) {
      let selectedLanguage = sessionStorage.getItem('language');
      if (selectedLanguage) {
        selectedLanguage = JSON.parse(selectedLanguage);
        setLanguage(selectedLanguage);
      }
    }
  }, [language]);

  const onLanguageChange = (language) => {
    console.log(language);
    sessionStorage.setItem('language', JSON.stringify(language));
    setLanguage(language);
  };

  return (
    <Sheet>
      <SheetTrigger  asChild>
          <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer">
            {language ? <img src={languageMap[language.code].src} alt={language.code} /> : <i className="mio">language</i>}
          </div>
      </SheetTrigger>
      <SheetContent>
        <SheetHeader className="shrink-0 panel-header">
          <SheetClose asChild>
            <Button>
              <i className="mio">arrow_back_ios</i>
            </Button>
          </SheetClose>
          <SheetTitle>Choose a Language</SheetTitle>
          <div></div>
        </SheetHeader>
        <div className={'overflow-y-auto grow'}>
          <Language onChange={onLanguageChange} lang={language}></Language>
        </div>
      </SheetContent>
    </Sheet>
  );
}
